(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7747],{

/***/ 8846:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/website-component",
      function () {
        return __webpack_require__(7089);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ website_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/utils/animation.ts
var animation = __webpack_require__(9428);
;// CONCATENATED MODULE: ./src/components/reuseable/website-tester-intro/index.js




var SeoAuditHeader = function(param) {
    var siteKey = param.siteKey;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " rounded-xl shadow-md border-l-4",
        style: (0,_object_spread/* default */.Z)({
            color: "#ccc !important"
        }, (0,animation/* fadeInAnimate */.St)("300ms")),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                style: {
                    color: "#333"
                },
                children: "SEO Audit"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-2 text-sm",
                style: {
                    color: "#333",
                    lineHeight: 1.475,
                    paddingTop: 12,
                    fontWeight: 300
                },
                children: [
                    "We have analysed ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: siteKey
                    }),
                    " and assessed how to improve your search engine rankings."
                ]
            })
        ]
    });
};
/* harmony default export */ var website_tester_intro = (SeoAuditHeader);

// EXTERNAL MODULE: ./src/hooks/useLogVisitor.js
var useLogVisitor = __webpack_require__(9588);
// EXTERNAL MODULE: ./src/components/reuseable/screen-canvas-config.ts
var screen_canvas_config = __webpack_require__(3378);
;// CONCATENATED MODULE: ./src/components/reuseable/ScreenCanvas.tsx







//@ts-ignore
var ScreenCanvas = function(param) {
    var //@ts-ignore
    fontSize = param.fontSize, //@ts-ignore
    siteData = param.siteData, //@ts-ignore
    domain = param.domain, //@ts-ignore
    extraVerticalPadding = param.extraVerticalPadding;
    // #region Loading
    var ref = (0,react.useState)(null), image = ref[0], setImage = ref[1];
    var ref1 = (0,react.useState)([]), elements = ref1[0], setElements = ref1[1];
    var ref2 = (0,react.useState)(true), loading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react.useState)(null), error = ref3[0], setError = ref3[1];
    var slots = screen_canvas_config/* config.slots */.v.slots, lineWidth = screen_canvas_config/* config.lineWidth */.v.lineWidth, screenshotWidth = screen_canvas_config/* config.screenshotWidth */.v.screenshotWidth, screenshotHeight = screen_canvas_config/* config.screenshotHeight */.v.screenshotHeight, canvasHeight = screen_canvas_config/* config.canvasHeight */.v.canvasHeight, canvasWidth = screen_canvas_config/* config.canvasWidth */.v.canvasWidth, padding = screen_canvas_config/* config.padding */.v.padding, //@ts-ignore
    industrySector = screen_canvas_config/* config.industrySector */.v.industrySector;
    var imageFolder = "/industry/".concat(industrySector, "/images");
    var jsonFolder = "/industry/".concat(industrySector);
    console.log("siteData Keywords (inside component):", siteData === null || siteData === void 0 ? void 0 : siteData.keywords);
    var tooltipRefs = (0,react.useRef)([]);
    var ref4 = (0,react.useState)({}), tooltipWidths = ref4[0], setTooltipWidths = ref4[1];
    // #endregion 
    // Load Data
    (0,react.useEffect)(function() {
        var loadData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var imageName, jsonName, imagePath, jsonPath, img, response, jsonData, websiteData, elements;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            imageName = "".concat(domain, "_desktop.webp");
                            jsonName = "".concat(domain, ".json");
                            imagePath = "".concat(imageFolder, "/").concat(imageName);
                            jsonPath = "".concat(jsonFolder, "/").concat(jsonName);
                            img = new Image();
                            img.src = imagePath;
                            _ctx.next = 9;
                            return new Promise(function(resolve, reject) {
                                img.onload = function() {
                                    return resolve(img);
                                };
                                img.onerror = function() {
                                    return reject(new Error("Failed to load image: ".concat(imagePath)));
                                };
                            });
                        case 9:
                            _ctx.next = 11;
                            return fetch(jsonPath);
                        case 11:
                            response = _ctx.sent;
                            if (response.ok) {
                                _ctx.next = 14;
                                break;
                            }
                            throw new Error("Failed to load JSON");
                        case 14:
                            _ctx.next = 16;
                            return response.json();
                        case 16:
                            jsonData = _ctx.sent;
                            websiteData = jsonData[domain];
                            if (websiteData) {
                                _ctx.next = 20;
                                break;
                            }
                            throw new Error("No data found for website: ".concat(domain));
                        case 20:
                            elements = websiteData.desktop.elements;
                            if (!(!elements || !Array.isArray(elements))) {
                                _ctx.next = 23;
                                break;
                            }
                            throw new Error("Invalid or missing 'elements' array in JSON data.");
                        case 23:
                            //@ts-ignore
                            setImage(img);
                            //@ts-ignore
                            setElements(elements);
                            setLoading(false);
                            _ctx.next = 32;
                            break;
                        case 28:
                            _ctx.prev = 28;
                            _ctx.t0 = _ctx["catch"](0);
                            //@ts-ignore
                            setError(_ctx.t0.message);
                            setLoading(false);
                        case 32:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        28
                    ]
                ]);
            }));
            return function loadData() {
                return _ref.apply(this, arguments);
            };
        }();
        loadData();
    }, [
        domain
    ]);
    // ** NEW WIDTHS FOR TOOLTIPS - based on text length?
    (0,react.useEffect)(function() {
        if (tooltipRefs.current.length > 0) {
            var newWidths = {};
            tooltipRefs.current.forEach(function(ref, index) {
                if (ref) {
                    //@ts-ignore
                    newWidths[index] = ref.offsetWidth;
                }
            });
            setTooltipWidths(newWidths);
        }
    }, [
        elements
    ]);
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: "Loading..."
    });
    if (error) return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            "Error: ",
            error
        ]
    });
    // #region Loading
    //@ts-ignore
    var scaleX = screenshotWidth / image.width;
    //@ts-ignore
    var scaleY = screenshotHeight / image.height;
    var usedSlots = new Set();
    // #endregion Loading
    // Function to check if two lines intersect
    //@ts-ignore
    var doLinesIntersect = function(line1, line2) {
        var _line1 = (0,_sliced_to_array/* default */.Z)(line1, 4), x1 = _line1[0], y1 = _line1[1], x2 = _line1[2], y2 = _line1[3]; // Line 1: (x1, y1) to (x2, y2)
        var _line2 = (0,_sliced_to_array/* default */.Z)(line2, 4), x3 = _line2[0], y3 = _line2[1], x4 = _line2[2], y4 = _line2[3]; // Line 2: (x3, y3) to (x4, y4)
        // Calculate the denominator
        var denominator = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
        // If the denominator is 0, the lines are parallel and do not intersect
        if (denominator === 0) return false;
        // Calculate the intersection point parameters
        var ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denominator;
        var ub = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / denominator;
        // Check if the intersection lies within both segments
        var epsilon = 0.0001; // Tolerance for floating-point precision
        return ua >= -epsilon && ua <= 1 + epsilon && ub >= -epsilon && ub <= 1 + epsilon;
    };
    //@ts-ignore
    var calculateLine = function(slot, boundingArea) {
        var tooltipCenterX = padding + slot.x + slot.width / 2;
        var tooltipCenterY = padding + slot.y + slot.height / 2;
        var centerX = (boundingArea[0] + boundingArea[2]) / 2;
        var centerY = (boundingArea[1] + boundingArea[3]) / 2;
        console.log("Tooltip Center:", {
            x: tooltipCenterX,
            y: tooltipCenterY
        });
        console.log("Bounding Area Center:", {
            x: centerX,
            y: centerY
        });
        return [
            tooltipCenterX,
            tooltipCenterY,
            centerX,
            centerY
        ];
    };
    // Function to check if two bounding areas overlap
    //@ts-ignore
    var doBoundingAreasOverlap = function(area1, area2) {
        var _area1 = (0,_sliced_to_array/* default */.Z)(area1, 4), x1 = _area1[0], y1 = _area1[1], x2 = _area1[2], y2 = _area1[3];
        var _area2 = (0,_sliced_to_array/* default */.Z)(area2, 4), x3 = _area2[0], y3 = _area2[1], x4 = _area2[2], y4 = _area2[3];
        return !(x2 <= x3 || x1 >= x4 || y2 <= y3 || y1 >= y4);
    };
    // #region Function to check for keyword matches
    //@ts-ignore
    var checkForKeywordMatches = function(text, keywords) {
        if (!text || !keywords) return [];
        //@ts-ignore
        return keywords.filter(function(keyword) {
            return text.toLowerCase().includes(keyword.toLowerCase());
        });
    };
    // #endregion
    var processElements = function() {
        //@ts-ignore
        var processedElements = [];
        //@ts-ignore
        var imgElements = []; // Track img elements to check for overlaps
        // Create a list of available slots
        var availableSlots = (0,_to_consumable_array/* default */.Z)(slots);
        // Sort elements by their position (e.g., top-to-bottom, left-to-right)
        var sortedElements = elements.map(function(element, index) {
            return {
                element: element,
                index: index
            };
        }).sort(function(a, b) {
            //@ts-ignore
            var aY = a.element.boundingArea[1];
            //@ts-ignore
            var bY = b.element.boundingArea[1];
            return aY - bY; // Sort by Y position (top-to-bottom)
        });
        // Process regular elements first
        sortedElements.forEach(function(param) {
            var element = param.element, index = param.index;
            //@ts-ignore
            var boundingArea = element.boundingArea || [
                0,
                0,
                0,
                0
            ];
            // Skip invalid bounding areas
            if (boundingArea.length !== 4 || //@ts-ignore
            boundingArea.every(function(val) {
                return val === 0;
            }) || boundingArea[0] <= 0 || boundingArea[1] <= 0 || boundingArea[0] >= screenshotWidth + padding || boundingArea[2] >= screenshotWidth + padding || boundingArea[1] >= canvasHeight - padding || boundingArea[3] >= screenshotHeight // Exclude elements exceeding bottom edge of screenshot
            ) {
                return;
            }
            // Skip small images or elements with excluded keywords
            var isSmallImage = boundingArea[2] - boundingArea[0] <= 45 && boundingArea[3] - boundingArea[1] <= 35;
            var hasExcludedKeywords = [
                "facebook",
                "google",
                "instagram",
                "twitter",
                "linkedin",
                "credit",
                "mastercard",
                "visa", 
            ].some(function(keyword) {
                return(//@ts-ignore
                (element.filename && //@ts-ignore
                element.filename.toLowerCase().includes(keyword)) || //@ts-ignore
                (element.alt && element.alt.toLowerCase().includes(keyword)));
            });
            if (isSmallImage || hasExcludedKeywords) {
                return;
            }
            // Transform bounding area based on scale and padding
            var transformedBoundingArea = [
                padding + boundingArea[0] * scaleX,
                padding + boundingArea[1] * scaleY,
                padding + boundingArea[2] * scaleX,
                padding + boundingArea[3] * scaleY, 
            ];
            // Check for overlapping images (moved after transformedBoundingArea is defined)
            //@ts-ignore
            if (element.type === "img") {
                //@ts-ignore
                var isOverlapping = imgElements.some(function(img) {
                    return doBoundingAreasOverlap(transformedBoundingArea, img.boundingArea);
                });
                if (isOverlapping) {
                    console.log("Skipping overlapping img element:", element);
                    return; // Skip overlapping img elements
                }
                imgElements.push({
                    element: element,
                    boundingArea: transformedBoundingArea
                });
            }
            // Calculate the center of the transformed bounding area
            var centerX = (transformedBoundingArea[0] + transformedBoundingArea[2]) / 2;
            var centerY = (transformedBoundingArea[1] + transformedBoundingArea[3]) / 2;
            // Find the closest available slot
            var closestSlot = null;
            var minDistance = Infinity;
            availableSlots.forEach(function(slot) {
                var slotCenterX = slot.x + slot.width / 2;
                var slotCenterY = slot.y + slot.height / 2;
                var distance = Math.sqrt(Math.pow(slotCenterX - centerX, 2) + Math.pow(slotCenterY - centerY, 2));
                if (distance < minDistance) {
                    minDistance = distance;
                    closestSlot = slot;
                }
            });
            // If no slot is found, skip rendering
            if (!closestSlot) {
                console.warn("No slot found for element:", element);
                return;
            }
            // Remove the assigned slot from available slots
            var slotIndex = availableSlots.indexOf(closestSlot);
            if (slotIndex !== -1) {
                availableSlots.splice(slotIndex, 1);
            }
            // Reduce width if the specific slot (x:10, y:400) overlaps with any bounding area
            //@ts-ignore
            if (closestSlot.x === 10 && closestSlot.y === 400) {
                var tooltipBoundingArea = [
                    //@ts-ignore
                    closestSlot.x,
                    //@ts-ignore
                    closestSlot.y,
                    //@ts-ignore
                    closestSlot.x + closestSlot.width,
                    //@ts-ignore
                    closestSlot.y + closestSlot.height, 
                ];
                //@ts-ignore
                var overlaps = elements.some(function(e) {
                    return(//@ts-ignore
                    doBoundingAreasOverlap(tooltipBoundingArea, e.boundingArea));
                });
                if (overlaps) {
                    console.log("Overlap detected, reducing tooltip width to 370px");
                    //@ts-ignore
                    closestSlot.width = 370;
                }
            }
            // Tooltip description logic
            var description = "";
            var isEligibleForSlot = true;
            var newKeywords = [
                "move",
                "moving"
            ];
            var keywordsToCheck = (siteData === null || siteData === void 0 ? void 0 : siteData.keywords) ? (0,_to_consumable_array/* default */.Z)(siteData.keywords).concat((0,_to_consumable_array/* default */.Z)(newKeywords)) : newKeywords;
            console.log("Keywords to Check:", keywordsToCheck); // Debug log
            //@ts-ignore
            if (element.type === "placeholder") {
                //@ts-ignore
                description = element.text;
            //@ts-ignore
            } else if ([
                "h1",
                "h2",
                "h3"
            ].includes(element.type)) {
                //@ts-ignore
                var matchedKeywords = element.text ? checkForKeywordMatches(element.text, keywordsToCheck) : [];
                console.log("Matched Keywords:", matchedKeywords); // Debug log
                //@ts-ignore
                console.log("Element Text:", element.text); // Debug log
                console.log("Keywords:", siteData === null || siteData === void 0 ? void 0 : siteData.keywords); // Debug log
                if (matchedKeywords.length > 0) {
                    description = "The heading contains the keyword".concat(matchedKeywords.length > 1 ? "s" : "", ' "').concat(matchedKeywords.join('", "'), '".');
                    isEligibleForSlot = false; // Not eligible if keywords are found
                } else {
                    description = "The heading does not contain any keywords.";
                    isEligibleForSlot = true; // Eligible if no keywords are found.
                }
            } else if (element.type === "img") {
                //@ts-ignore
                var imageMatchedKeywords = element.filename ? checkForKeywordMatches(element.filename, keywordsToCheck) : [];
                //@ts-ignore
                var altMatchedKeywords = element.alt ? checkForKeywordMatches(element.alt, keywordsToCheck) : [];
                if (imageMatchedKeywords.length > 0 && altMatchedKeywords.length > 0) {
                    // Both filename and alt text contain keywords
                    isEligibleForSlot = false; // Not eligible for a slot
                    description = ""; // No message shown
                } else if (imageMatchedKeywords.length > 0) {
                    // Only filename contains keywords
                    isEligibleForSlot = true; // Eligible for a slot
                    description = "The alternative text does not contain any keywords.";
                } else if (altMatchedKeywords.length > 0) {
                    // Only alt text contains keywords
                    isEligibleForSlot = true; // Eligible for a slot
                    description = "The image filename does not contain any keywords.";
                } else {
                    // Neither filename nor alt text contains keywords
                    isEligibleForSlot = true; // Eligible for a slot
                    description = "Both the image filename and alternative text contain no keywords.";
                }
            }
            // Skip rendering if the element is not eligible for a slot
            if (!isEligibleForSlot) {
                console.log("Skipping ineligible element:", element);
                return;
            }
            // Calculate the line from the slot to the bounding area
            var line = calculateLine(closestSlot, transformedBoundingArea);
            // Add the processed element
            processedElements.push({
                element: element,
                assignedSlot: closestSlot,
                line: line,
                boundingArea: transformedBoundingArea,
                description: description
            });
        });
        // Check for intersections and swap slots if necessary
        for(var i = 0; i < processedElements.length; i++){
            for(var j = i + 1; j < processedElements.length; j++){
                //@ts-ignore
                var line1 = processedElements[i].line;
                //@ts-ignore
                var line2 = processedElements[j].line;
                if (doLinesIntersect(line1, line2)) {
                    // Swap slots for the intersecting tooltips
                    //@ts-ignore
                    var temp = processedElements[i].assignedSlot;
                    //@ts-ignore
                    processedElements[i].assignedSlot = processedElements[j].assignedSlot;
                    //@ts-ignore
                    processedElements[j].assignedSlot = temp;
                    // Recalculate lines after swapping
                    //@ts-ignore
                    processedElements[i].line = calculateLine(//@ts-ignore
                    processedElements[i].assignedSlot, //@ts-ignore
                    processedElements[i].boundingArea);
                    //@ts-ignore
                    processedElements[j].line = calculateLine(//@ts-ignore
                    processedElements[j].assignedSlot, //@ts-ignore
                    processedElements[j].boundingArea);
                }
            }
        }
        // Only process the following checks if there are available slots
        if (availableSlots.length > 0) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
            //@ts-ignore
            var hasH1 = elements.some(function(el) {
                return(//@ts-ignore
                el.type === "h1" && //@ts-ignore
                el.text !== false && //@ts-ignore
                el.boundingArea && //@ts-ignore
                el.boundingArea.length === 4 && //@ts-ignore
                !el.boundingArea.every(function(val) {
                    return val === 0;
                }));
            });
            // If no valid H1 is found, add a placeholder element to indicate no main heading
            if (!hasH1 && availableSlots.length > 0) {
                var lastSlot = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "No main heading (H1) in the intro screen.",
                    assignedSlot: lastSlot,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "No main heading (H1) in the intro screen."
                });
                availableSlots.pop(); // Remove the last slot from available slots
            }
            // Additional checks for sitemap, robots.txt, and other conditions
            var sitemapPass = !!(siteData === null || siteData === void 0 ? void 0 : siteData.sitemap);
            var robotsPass = !!(siteData === null || siteData === void 0 ? void 0 : (ref = siteData.robotsTxt) === null || ref === void 0 ? void 0 : ref.exists);
            if (!sitemapPass && availableSlots.length > 0) {
                var lastSlot1 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "There is no Sitemap.",
                    assignedSlot: lastSlot1,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "There is no Sitemap."
                });
                availableSlots.pop();
            }
            if (!robotsPass && availableSlots.length > 0) {
                var lastSlot2 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "There is no Robots.txt.",
                    assignedSlot: lastSlot2,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "There is no Robots.txt."
                });
                availableSlots.pop();
            }
            // PageSpeed checks
            //@ts-ignore
            var parseSpeedValue = function(value) {
                if (!value) return 0;
                return parseFloat(value.replace(/[^0-9.]/g, "")); // Remove non-numeric characters and parse
            };
            var speedIndexPass = parseSpeedValue(siteData === null || siteData === void 0 ? void 0 : (ref1 = siteData.pagespeed) === null || ref1 === void 0 ? void 0 : ref1.speedIndex) <= 2;
            var fcpPass = parseSpeedValue(siteData === null || siteData === void 0 ? void 0 : (ref2 = siteData.pagespeed) === null || ref2 === void 0 ? void 0 : ref2.firstContentfulPaint) <= 2;
            var interactivePass = parseSpeedValue(siteData === null || siteData === void 0 ? void 0 : (ref3 = siteData.pagespeed) === null || ref3 === void 0 ? void 0 : ref3.interactive) <= 3;
            var responsiveImagesPass = !(siteData === null || siteData === void 0 ? void 0 : (ref4 = siteData.pagespeed) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.usesResponsiveImages) === null || ref5 === void 0 ? void 0 : ref5.includes("Potential savings"));
            var unminJSPass = !(siteData === null || siteData === void 0 ? void 0 : (ref6 = siteData.pagespeed) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.unminifiedJavaScript) === null || ref7 === void 0 ? void 0 : ref7.includes("Potential savings"));
            var unminCSSPass = !(siteData === null || siteData === void 0 ? void 0 : (ref8 = siteData.pagespeed) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.unminifiedCss) === null || ref9 === void 0 ? void 0 : ref9.includes("Potential savings"));
            var renderBlockingPass = !(siteData === null || siteData === void 0 ? void 0 : (ref10 = siteData.pagespeed) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.renderBlockingResources) === null || ref11 === void 0 ? void 0 : ref11.includes("Potential savings"));
            var byteWeightPass = parseSpeedValue(siteData === null || siteData === void 0 ? void 0 : (ref12 = siteData.pagespeed) === null || ref12 === void 0 ? void 0 : ref12.totalByteWeight) <= 2000;
            var networkRequestsPass = (siteData === null || siteData === void 0 ? void 0 : (ref13 = siteData.pagespeed) === null || ref13 === void 0 ? void 0 : ref13.networkRequests) === "N/A";
            var redirectsPass = (siteData === null || siteData === void 0 ? void 0 : (ref14 = siteData.pagespeed) === null || ref14 === void 0 ? void 0 : ref14.redirects) === "N/A";
            var readabilityPass = (siteData === null || siteData === void 0 ? void 0 : (ref15 = siteData.readability) === null || ref15 === void 0 ? void 0 : ref15.score) > 70;
            var contentLengthPass = (siteData === null || siteData === void 0 ? void 0 : (ref16 = siteData.contentLength) === null || ref16 === void 0 ? void 0 : ref16.status) === true;
            var headingHierarchyPass = !!(siteData === null || siteData === void 0 ? void 0 : (ref17 = siteData.headingHierarchy) === null || ref17 === void 0 ? void 0 : ref17.status);
            var annotatedWebpPass = !!(siteData === null || siteData === void 0 ? void 0 : siteData.annotatedWebp);
            var hasPageSpeedFailure = !speedIndexPass || !fcpPass || !interactivePass;
            if (hasPageSpeedFailure && availableSlots.length > 0) {
                var lastSlot3 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "Page Speed issues detected.",
                    assignedSlot: lastSlot3,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "Page speed issues detected."
                });
                availableSlots.pop();
            }
            // Responsive Images Check
            if (!responsiveImagesPass && availableSlots.length > 0) {
                var lastSlot4 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "The website uses images that are not responsive, which can negatively impact performance on different devices.",
                    assignedSlot: lastSlot4,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "The website uses images that are not responsive, which can negatively impact performance on different devices."
                });
                availableSlots.pop();
            }
            // Unminified JavaScript Check
            if (!unminJSPass && availableSlots.length > 0) {
                var lastSlot5 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "The website contains JavaScript code that has not been compressed, which can increase load times.",
                    assignedSlot: lastSlot5,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "The website contains unminified JavaScript, which can increase load times."
                });
                availableSlots.pop();
            }
            // Unminified CSS Check
            if (!unminCSSPass && availableSlots.length > 0) {
                var lastSlot6 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "The website contains unminified CSS, which can increase load times.",
                    assignedSlot: lastSlot6,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "The website contains unminified CSS, which can increase load times."
                });
                availableSlots.pop();
            }
            // Render Blocking Resources Check
            if (!renderBlockingPass && availableSlots.length > 0) {
                var lastSlot7 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "The website has a lot of code that is not necessary for the most important content, so it makes the page slow.",
                    assignedSlot: lastSlot7,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "The website has render-blocking resources, which can delay page rendering."
                });
                availableSlots.pop();
            }
            // Byte Weight Check
            if (!byteWeightPass && availableSlots.length > 0) {
                var lastSlot8 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "The website has a very high total file size, which slows down the loading of the page.",
                    assignedSlot: lastSlot8,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "The website has a high total byte weight, which can slow down page load times."
                });
                availableSlots.pop();
            }
            // Network Requests Check
            if (!networkRequestsPass && availableSlots.length > 0) {
                var lastSlot9 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "The website downloads too many individual items, which significantly slows the page loading.",
                    assignedSlot: lastSlot9,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "The website downloads too many individual items, which significantly slows the page loading."
                });
                availableSlots.pop();
            }
            // Redirects Check
            if (!redirectsPass && availableSlots.length > 0) {
                var lastSlot10 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "The website has unnecessary redirects, which can slow down page load times.",
                    assignedSlot: lastSlot10,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "The website has unnecessary redirects, which can slow down page load times."
                });
                availableSlots.pop();
            }
            // Readability Check
            if (!readabilityPass && availableSlots.length > 0) {
                var lastSlot11 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "The website's readability score is below 70, which may affect user engagement.",
                    assignedSlot: lastSlot11,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "The website's readability score is below 70, which may affect user engagement."
                });
                availableSlots.pop();
            }
            // Content Length Check
            if (!contentLengthPass && availableSlots.length > 0) {
                var lastSlot12 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "The website's content length is insufficient, which may impact SEO and user engagement.",
                    assignedSlot: lastSlot12,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "The website's content length is insufficient, which may impact SEO and user engagement."
                });
                availableSlots.pop();
            }
            // Heading Hierarchy Check
            if (!headingHierarchyPass && availableSlots.length > 0) {
                var lastSlot13 = availableSlots[availableSlots.length - 1];
                processedElements.push({
                    type: "placeholder",
                    text: "The website's heading hierarchy is not properly structured, which can affect SEO and accessibility.",
                    assignedSlot: lastSlot13,
                    boundingArea: [
                        0,
                        0,
                        0,
                        0
                    ],
                    description: "The website's heading hierarchy is not properly structured, which can affect SEO and accessibility."
                });
                availableSlots.pop();
            }
        // Annotated WebP Check
        // if (!annotatedWebpPass && availableSlots.length > 0) {
        //   const lastSlot = availableSlots[availableSlots.length - 1];
        //   processedElements.push({
        //     type: "placeholder",
        //     text: "The website does not use compressed WebP images, which can improve performance and reduce file sizes.",
        //     assignedSlot: lastSlot,
        //     boundingArea: [0, 0, 0, 0], // Dummy bounding area
        //     description: "The website does not use compressed WebP images, which can improve performance and reduce file sizes.",
        //   });
        //   availableSlots.pop();
        // }
        }
        return processedElements;
    };
    var processedElements = processElements();
    console.log("Processed Elements:", processedElements);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            position: "relative",
            overflow: "visible"
        },
        className: "tooltips",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    position: "relative",
                    borderRadius: "16px",
                    width: "".concat(canvasWidth + extraVerticalPadding, "px"),
                    height: "4000px",
                    overflow: "hidden"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        position: "absolute",
                        top: padding,
                        left: padding,
                        width: "".concat(screenshotWidth - 20, "px"),
                        height: "".concat(canvasHeight + extraVerticalPadding, "px"),
                        borderRadius: "16px",
                        overflow: "hidden"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        //@ts-ignore
                        src: image.src,
                        alt: "Website Screenshot",
                        style: {
                            width: "".concat(screenshotWidth, "px"),
                            height: "".concat(screenshotHeight, "px"),
                            objectFit: "cover"
                        }
                    })
                })
            }),
            Object.entries(processedElements).map(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], element = _param[1];
                var index = parseInt(key, 10); // Convert the key (string) to a number
                var assignedSlot = element.assignedSlot, boundingArea = element.boundingArea, description = element.description, type = element.type;
                // if (!assignedSlot) {
                //   console.warn(`Skipping element at index ${index} due to missing assignedSlot`);
                //   return null;
                // }
                //@ts-ignore
                var tooltipWidth = tooltipWidths[index] || 300;
                var centerX = (boundingArea[0] + boundingArea[2]) / 2;
                var centerY = (boundingArea[1] + boundingArea[3]) / 2;
                var lineStartX = assignedSlot.x + tooltipWidth / 2;
                var lineStartY = assignedSlot.y;
                if (!assignedSlot) {
                    console.warn("Skipping element at index ".concat(index, " due to missing assignedSlot"));
                    return null;
                }
                // Set the tooltip width based on assignedSlot.y and assignedSlot.x
                var widthHere = assignedSlot.y === 400 && assignedSlot.x === 10 ? 370 : "auto"; // Apply 370px width if y=400 and x=10, otherwise 'auto'
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        type !== "placeholder" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            //@ts-ignore
                            className: index,
                            style: {
                                position: "absolute",
                                top: lineStartY,
                                left: lineStartX,
                                width: Math.sqrt(Math.pow(centerX - lineStartX, 2) + Math.pow(centerY - lineStartY, 2)),
                                height: lineWidth,
                                backgroundColor: "black",
                                transform: "rotate(".concat(Math.atan2(centerY - lineStartY, centerX - lineStartX), "rad)"),
                                transformOrigin: "0 0"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            //@ts-ignore
                            ref: function(el) {
                                return tooltipRefs.current[index] = el;
                            },
                            style: {
                                position: "absolute",
                                letterSpacing: "-1px",
                                top: assignedSlot.y,
                                left: assignedSlot.x,
                                width: widthHere,
                                minWidth: "300px",
                                maxWidth: "1000px",
                                backgroundColor: "white",
                                border: "2px solid black",
                                color: "#333",
                                borderRadius: "40px",
                                padding: "15px 15px 20px 25px",
                                fontSize: "".concat(fontSize, "px"),
                                lineHeight: 1.2,
                                pointerEvents: "none",
                                zIndex: 10
                            },
                            children: description
                        })
                    ]
                }, index);
            })
        ]
    });
};
/* harmony default export */ var reuseable_ScreenCanvas = (ScreenCanvas);

;// CONCATENATED MODULE: ./pages/website-component.tsx












// import { config } from "../src/config/website-component-config";

"use client";
var WebsiteTester = function() {
    var bgColor = screen_canvas_config/* config.bgColor */.v.bgColor, screenshotWidth = screen_canvas_config/* config.screenshotWidth */.v.screenshotWidth, screenshotHeight = screen_canvas_config/* config.screenshotHeight */.v.screenshotHeight, PADDING = screen_canvas_config/* config.PADDING */.v.PADDING, extraVerticalPadding = screen_canvas_config/* config.extraVerticalPadding */.v.extraVerticalPadding, industrySector = screen_canvas_config/* config.industrySector */.v.industrySector;
    (0,useLogVisitor/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(null), siteKey = ref[0], setSiteKey = ref[1];
    var ref1 = (0,react.useState)(34), fontSize = ref1[0], setFontSize = ref1[1]; // Default font size
    var ref2 = (0,react.useState)(null), siteData = ref2[0], setSiteData = ref2[1];
    var ref3 = (0,react.useState)(true), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react.useState)(null), error = ref4[0], setError = ref4[1];
    (0,react.useEffect)(function() {
        var query = new URLSearchParams(window.location.search);
        var siteKeyParam = query.get("visitor");
        var fontSizeParam = query.get("fontSize");
        if (siteKeyParam) {
            setSiteKey(siteKeyParam);
        } else {
            setError("Site key is missing from the URL.");
            setLoading(false);
        }
        if (fontSizeParam) {
            var parsedFontSize = parseInt(fontSizeParam, 10);
            if (!isNaN(parsedFontSize)) {
                setFontSize(parsedFontSize); // ✅ Set fontSize if valid
            }
        }
    }, [
        router.query
    ]);
    (0,react.useEffect)(function() {
        if (siteKey) {
            var loadSiteData = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var response, data;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                setLoading(true);
                                setError(null);
                                _ctx.prev = 2;
                                _ctx.next = 5;
                                return fetch("/industry/".concat(industrySector, "/").concat(siteKey, ".json"));
                            case 5:
                                response = _ctx.sent;
                                if (response.ok) {
                                    _ctx.next = 8;
                                    break;
                                }
                                throw new Error("Failed to fetch site data for ".concat(siteKey));
                            case 8:
                                _ctx.next = 10;
                                return response.json();
                            case 10:
                                data = _ctx.sent;
                                setSiteData(data[siteKey]);
                                _ctx.next = 17;
                                break;
                            case 14:
                                _ctx.prev = 14;
                                _ctx.t0 = _ctx["catch"](2);
                                setError("Error: ".concat(_ctx.t0.message));
                            case 17:
                                _ctx.prev = 17;
                                setLoading(false);
                                return _ctx.finish(17);
                            case 20:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            14,
                            17,
                            20
                        ]
                    ]);
                }));
                return function loadSiteData() {
                    return _ref.apply(this, arguments);
                };
            }();
            loadSiteData();
        }
    }, [
        siteKey
    ]);
    var imageRef = (0,react.useRef)(null);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "Loading..."
        });
    }
    if (error) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: error
        });
    }
    var sortedElements = (0,_to_consumable_array/* default */.Z)((siteData === null || siteData === void 0 ? void 0 : siteData.elements) || []).filter(function(el) {
        return Array.isArray(el.boundingArea) && el.boundingArea.length === 4;
    }).sort(function(a, b) {
        var _boundingArea = (0,_sliced_to_array/* default */.Z)(a.boundingArea, 2), ax1 = _boundingArea[0], ay1 = _boundingArea[1];
        var _boundingArea1 = (0,_sliced_to_array/* default */.Z)(b.boundingArea, 2), bx1 = _boundingArea1[0], by1 = _boundingArea1[1];
        if (typeof ax1 !== "number" || typeof ay1 !== "number" || typeof bx1 !== "number" || typeof by1 !== "number") {
            return 0;
        }
        return ay1 - by1 || ax1 - bx1;
    });
    var sortedSiteData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, siteData), {
        elements: sortedElements
    });
    console.log("sortedSiteData2 Keywords (inside component):", sortedSiteData === null || sortedSiteData === void 0 ? void 0 : sortedSiteData.keywords);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
            className: "",
            style: {
                backgroundColor: bgColor
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                style: {
                    margin: 0,
                    backgroundColor: bgColor,
                    width: screenshotWidth + PADDING * 2,
                    height: screenshotHeight + PADDING * 2,
                    borderRadius: 8
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative order-1 order-lg-2 pb-15",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "d-block d-lg-none pb-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(website_tester_intro, {
                                    siteKey: siteKey
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(reuseable_ScreenCanvas, {
                                fontSize: fontSize,
                                padding: PADDING,
                                extraVerticalPadding: extraVerticalPadding,
                                industrySector: industrySector,
                                domain: siteKey,
                                siteData: sortedSiteData,
                                imageRef: imageRef,
                                screenshotWidth: screenshotWidth,
                                screenshotHeight: screenshotHeight
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: '<style>\n                        header,[data-testid="injected-notifications-test-ids-open-notification"] {\n                            display: none !important; left: -9999 !important\n                        }\n                        </style>'
                        }
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var website_component = (WebsiteTester);


/***/ }),

/***/ 3378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ config; }
/* harmony export */ });
/* provided dependency */ var process = __webpack_require__(4155);
var screenshotWidth = 1920;
var screenshotHeight = 1080;
var padding = 130;
var extraVerticalPadding = 200;
var config = {
    screenshotWidth: screenshotWidth,
    screenshotHeight: screenshotHeight,
    padding: padding,
    extraVerticalPadding: extraVerticalPadding,
    canvasWidth: 1920 + padding * 2,
    canvasHeight: 1080 + padding * 2 + extraVerticalPadding,
    bgColor: "#eceef3",
    adjustedBgColor: "#eeedf2",
    maxTooltipWidth: 800,
    tooltipPadding: 10,
    tooltipBorderRadius: 16,
    industrySector: "solicitor",
    fontSizes: [
        process.env.SCREENSHOT_FONT_SIZE_LG || "34",
        process.env.SCREENSHOT_FONT_SIZE_MD || "44",
        process.env.SCREENSHOT_FONT_SIZE_SM || "54"
    ],
    slots: [
        {
            y: 2,
            x: 10,
            width: 1000,
            height: 100
        },
        {
            y: 5,
            x: 1150,
            width: 100,
            height: 100
        },
        {
            y: 400,
            x: 10,
            maxWidth: 500,
            width: 100,
            height: 100
        },
        {
            y: 1210,
            x: 20,
            width: 100,
            height: 100
        },
        {
            y: 1190,
            x: 1120,
            width: 100,
            height: 100
        }
    ],
    lineWidth: 2
};


/***/ }),

/***/ 9588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
// useLogVisitor.js


var useLogVisitor = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var visitor = Array.isArray(router.query.visitor) ? router.query.visitor[0] : router.query.visitor;
        if (visitor) {
            fetch("/api/log-visitor/?visitor=".concat(encodeURIComponent(visitor))).then(function(response) {
                return response.json();
            }).then(function(data) {
                console.log("Visitor logged:", data.message);
            }).catch(function(error) {
                console.error("Error logging visitor:", error);
            });
        }
    }, [
        router.query.visitor
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useLogVisitor);


/***/ }),

/***/ 9428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "St": function() { return /* binding */ fadeInAnimate; }
/* harmony export */ });
/* unused harmony exports slideInDownAnimate, zoomInAnimate */
var animation = function(param) {
    var name = param.name, delay = param.delay;
    return {
        animationName: name,
        animationDelay: delay,
        animationFillMode: "both",
        animationDuration: "700ms",
        animationDirection: "normal",
        animationTimingFunction: "ease"
    };
};
var slideInDownAnimate = function(delay) {
    return animation({
        name: "slideInDown",
        delay: delay
    });
};
var zoomInAnimate = function(delay) {
    return animation({
        name: "zoomIn",
        delay: delay
    });
};
var fadeInAnimate = function(delay) {
    return animation({
        name: "fadeIn",
        delay: delay
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (animation)));


/***/ }),

/***/ 943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 3375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(1566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 9815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(1566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 1566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(8846); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);